// MAIN FONT LOOKUP May 25, 2022
// src: https://github.com/Myndex/apca-w3
// Sorted by Font Size
// First row is standard weights 100-900
// First column is font size in px
// All other values are the Lc contrast 
// 999 = too low. 777 = non-text and spot text only

const lookup = [
	['px',100,200,300,400,500,600,700,800,900],
	[10,999,999,999,999,999,999,999,999,999],
	[12,999,999,999,777,777,777,777,999,999],
	[14,999,999,777,100,100,90,75,999,999],
	[15,999,999,777,100,90,75,70,999,999],
	[16,999,999,777,90,75,70,60,60,999],
	[18,999,777,100,75,70,60,55,55,55],
	[21,999,777,90,70,60,55,50,50,50],
	[24,999,777,75,60,55,50,45,45,45],
	[28,999,100,70,55,50,45,43,43,43],
	[32,999,90,65,50,45,43,40,40,40],
	[36,999,75,60,45,43,40,38,38,38],
	[42,100,70,55,43,40,38,35,35,35],
	[48,90,60,50,40,38,35,33,33,33],
	[60,75,55,45,38,35,33,30,30,30],
	[72,60,50,40,35,33,30,30,30,30],
	[96,50,45,35,33,30,30,30,30,30],
];

const sizes = lookup.slice(1).map(arr => arr[0])
const weights = lookup[0].slice(1)

export const calculateLcValues = (size, ratios, weight) => {
	// Gives min and max Lc values for a given font size, reference ratio and font weight
	// Values are returned in an array for body text, sub-fluent text and non-fluent text

	size *= ratios.refRatio
	weight = +ratios.weights[weight] || +weight

	const [lookupSize, lookupSizeRatio] = sizes.reduce((data, s, i) => {
		if (data) return data
		if (size > s) return null // Keep going until size is smaller than lookup
		if (size === s) return [i + 1, 1] // If the exact size is in the table, set ratio to 1
		if (i === 0) return [1, 1] // If font size is smaller than 10px, use 10px values

		// Once font size is smaller than lookup size, calculate ratio
		return [i + 1, size / s]
	}, null)
	const lookupWeight = weights.indexOf(weight) + 1

	const lc = Math.round(lookup[lookupSize][lookupWeight] * lookupSizeRatio)

	return [
		lc < 75 ? (lc + 15 > 75 ? 75 : lc + 15) : lc, // For body text, add Lc 15 for any value on the table lower than Lc 75
		lc - 15 < 30 ? 30 : lc - 15, // For sub-fluent text (i.e. not primary content) Lc values can be lowered by Lc 15, but in no case less than Lc 30
		lc - 25 < 30 ? 30 : lc - 25, // For non-fluent spot text (copyright bug, disabled text, placeholder) Lc values can be lowered by Lc25, but in no case less than Lc 30
		// size > 24 && weight > 300 ? 90 : 100 // Fonts larger than 24px and weight 300 or more have a maximum contrast of Lc 90
	]
}